import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import i18n from "../i18n/i18n.js";
import { auth } from "@/plugins/checkAuth.js";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/main/index.vue"),
    meta: { requireAuth: true },
    children: [
      {
        path: "",
        name: "home",
        component: () => import("../views/main/home.vue"),
      },
      {
        path: "/chats",
        name: "chat",
        component: () => import("../views/main/chats/index.vue"),
        children: [
          {
            path: "/chats/:id",
            name: "client",
            component: () => import("../views/main/chats/client_room.vue"),
            meta: {
              check: true,
            },
          },
          {
            path: "/chats/internal/:id",
            name: "internal",
            component: () => import("../views/main/chats/internal_room.vue"),
            meta: {
              checkInnerText: true,
            },
          },
          {
            path: "/chats/videoCall/:id",
            name: "videoCall",
            component: () => import("../views/main/chats/video_room.vue"),
          },
        ],
      },
      // {
      //   path: "/videoCall/:id",
      //   name: "videoCall-room",
      //   component: () => import("../views/main/videoCall/video_room.vue"),
      // },
      // history
      {
        path: "/history",
        redirect: "/history/client",
        name: "history",
        component: () => import("../views/main/history/index.vue"),
        children: [
          {
            path: "/history/client",
            name: "history-client",
            component: () => import("../views/main/history/client.vue"),
            meta: { keepAlive: true },
          },
          {
            path: "/history/client/:id",
            name: "history-client-detail",
            component: () => import("../views/main/history/_client.vue"),
          },
          {
            path: "/history/internal",
            name: "history-internal",
            component: () => import("../views/main/history/internal.vue"),
            meta: { keepAlive: true },
          },
          {
            path: "/history/internal/:id",
            name: "history-internal-detail",
            component: () => import("../views/main/history/_internal.vue"),
          },
          {
            path: "/history/keyword",
            name: "history-keyword",
            component: () => import("../views/main/history/keyword.vue"),
            meta: { keepAlive: true },
          },
          {
            path: "/history/videoCall",
            name: "videoCall-client-history",
            component: () => import("../views/main/history/videoCall.vue"),
            meta: { keepAlive: true },
          },
        ],
      },
      // chatcase
      {
        path: "/chatcase",
        name: "chatcase",
        component: () => import("../views/main/chatcase.vue"),
      },
      // reports
      {
        path: "",
        component: () => import("../views/main/reports/index.vue"),
        children: [
          {
            path: "/reports",
            name: i18n.t("REPORT.NAV.AGENT_DAILYSATUS"),
            component: () =>
              import("../views/main/reports/AgentDailyStatusReport.vue"),
          },
          {
            path: "/reports/dailyTimeline",
            name: i18n.t("REPORT.NAV.AGENT_DAILYSATUS_CHART"),
            component: () =>
              import("../views/main/reports/AgentDailyTimeline.vue"),
          },
          {
            path: "/reports/CSAT",
            name: i18n.t("REPORT.NAV.CSAT"),
            component: () => import("../views/main/reports/CSAT.vue"),
          },
          {
            path: "/reports/OverallAgentSatisfaction",
            name: i18n.t("REPORT.NAV.OVERALL_AGENT_SATISFACTION"),
            component: () =>
              import("../views/main/reports/OverallAgentSatisfaction.vue"),
          },
          {
            path: "/reports/OverallSkillSatisfaction",
            name: i18n.t("REPORT.NAV.OVERALL_SKILL_SATISFACTION"),
            component: () =>
              import("../views/main/reports/OverallSkillSatisfaction.vue"),
          },
          {
            path: "/reports/AgentKPIandOccupancyReport",
            name: i18n.t("REPORT.NAV.AGENT_KPIOCCUPANCY"),
            component: () =>
              import("../views/main/reports/AgentKPIandOccupancyReport.vue"),
          },
          {
            path: "/reports/BillingReport",
            name: i18n.t("REPORT.NAV.COST_REPORT"),
            component: () => import("../views/main/reports/BillingReport.vue"),
          },
          {
            path: "/reports/VideoCallBillingReport",
            name: i18n.t("REPORT.NAV.VIDEO_COST_REPORT"),
            component: () =>
              import("../views/main/reports/VideoCallBillingReport.vue"),
          },
          {
            path: "/reports/HourlyServicesStatistics",
            name: i18n.t("REPORT.NAV.COST_HOURLY"),
            component: () =>
              import("../views/main/reports/HourlyServicesStatistics.vue"),
          },
          {
            path: "/reports/KPIReport",
            name: i18n.t("REPORT.NAV.KPI_REPORT"),
            component: () => import("../views/main/reports/KPIReport.vue"),
          },
          {
            path: "/reports/KPIReport_SkillView",
            name: i18n.t("REPORT.NAV.KPI_REPORT_SKILL"),
            component: () =>
              import("../views/main/reports/KPIReport_SkillView.vue"),
          },
          {
            path: "/reports/KPIReportHourly",
            name: i18n.t("REPORT.NAV.KPI_REPORT_HOURLY"),
            component: () =>
              import("../views/main/reports/KPIReportHourly.vue"),
          },
          {
            path: "/reports/KPIReport_SkillView_Hourly",
            name: i18n.t("REPORT.NAV.KPI_REPORT_SKILL_HOURLY"),
            component: () =>
              import("../views/main/reports/KPIReport_SkillView_Hourly.vue"),
          },
          {
            path: "/reports/AHTReport",
            name: i18n.t("REPORT.NAV.AHT_REPORT"),
            component: () => import("../views/main/reports/AHTReport.vue"),
          },
          {
            path: "/reports/AHTReport_SkillView",
            name: i18n.t("REPORT.NAV.AHT_REPORT_SKILL"),
            component: () =>
              import("../views/main/reports/AHTReport_SkillView.vue"),
          },
          {
            path: "/reports/funnelChart",
            name: "Funnel Chart (Beta)",
            component: () => import("../views/main/reports/funnelChart.vue"),
          },
        ],
      },
      // ACD
      {
        path: "/acd_monitor",
        name: "acd_monitor-index",
        redirect: "/acd_monitor/summary",
        component: () => import("../views/main/acd/index.vue"),
        children: [
          {
            path: "/acd_monitor/agentState",
            name: "acd-agentState",
            component: () => import("../views/main/acd/agentState.vue"),
            meta: { keepAlive: true },
          },
          {
            path: "/acd_monitor/serviceLevel",
            name: "acd-serviceLevel",
            component: () => import("../views/main/acd/serviceLevel.vue"),
            meta: { keepAlive: true },
          },
          {
            path: "/acd_monitor/summary",
            name: "acd-summary",
            component: () => import("../views/main/acd/summary.vue"),
            meta: { keepAlive: true },
          },
        ],
      },
      // Dashboard
      {
        path: "",
        component: () => import("../views/main/dashboard/index.vue"),
        children: [
          {
            path: "/dashboard",
            name: "dashboard-index",
            component: () => import("../views/main/dashboard/MainMointor.vue"),
            meta: { keepAlive: true },
          },
          {
            path: "/dashboard/AHT",
            name: "dashboard-AHT",
            component: () => import("../views/main/dashboard/AHT.vue"),
          },
          {
            path: "/dashboard/status",
            name: "dashboard-agent-status",
            component: () => import("../views/main/dashboard/AgentStatus.vue"),
          },
          {
            path: "/dashboard/CSAT",
            name: "dashboard-CSAT",
            component: () => import("../views/main/dashboard/CSAT.vue"),
          },
        ],
      },
      // Setting
      {
        path: "/setting",
        component: () => import("../views/main/setting/index.vue"),
        children: [
          // Profile
          {
            path: "/setting/profile",
            component: () => import("../views/main/setting/profile/index.vue"),
            meta: { name: "Profile" },
            children: [
              {
                path: "",
                name: i18n.t("SETTING.PERSONAL.PROFILE.TITLE"),
                component: () =>
                  import("../views/main/setting/profile/profile.vue"),
              },
              {
                path: "/setting/canned_list_personal",
                name: i18n.t(
                  "SETTING.INDEX.PERSONAL_EDIT_CANNEDRESPONSE_SETTING",
                ),
                component: () =>
                  import(
                    "../views/main/setting/profile/canned_list_personal.vue"
                  ),
              },
              {
                path: "/setting/canned_list_public",
                name: i18n.t("SETTING.INDEX.PUBLIC_CANNEDRESPONSE_LIST"),
                component: () =>
                  import(
                    "../views/main/setting/profile/canned_list_public.vue"
                  ),
              },
              {
                path: "/setting/canned_group",
                name: i18n.t("SETTING.CANNED.EDIR_GROUP"),
                component: () =>
                  import("../views/main/setting/profile/canned_group_list.vue"),
              },
              {
                path: "/setting/canned_create",
                name: i18n.t("SETTING.CANNED.CREATE_PERSONAL_CANNED"),
                component: () =>
                  import("../views/main/setting/profile/canned_create.vue"),
              },
              {
                path: "/setting/canned_list_personal/:cannedId",
                name: i18n.t("SETTING.CANNED.EDIT_PERSONAL_CANNED"),
                component: () =>
                  import("../views/main/setting/profile/canned_edit.vue"),
              },
            ],
          },
          // Chat
          {
            path: "/setting/chat/basic",
            component: () => import("../views/main/setting/chat/index.vue"),
            meta: { name: "Profile" },
            children: [
              {
                path: "",
                name: i18n.t("SETTING.CHAT.BASIC.SELECT_COUNTRY"),
                component: () =>
                  import("../views/main/setting/_SelectLoginUserCountry.vue"),
              },
              {
                path: "/setting/chat/basic/:countryId",
                name: i18n.t("SETTING.CHAT.BASIC.TITLE"),
                component: () => import("../views/main/setting/chat/basic.vue"),
              },
              {
                path: "/setting/chat/sys",
                name: i18n.t("SETTING.CHAT.COPYRIGHT.SELECT_COUNTRY"),
                component: () =>
                  import("../views/main/setting/_SelectLoginUserCountry.vue"),
                meta: {
                  childPath: "beforeChat",
                },
              },
              {
                path: "/setting/chat/sys/:countryId/beforeChat",
                component: () =>
                  import("../views/main/setting/chat/sys/index.vue"),
                children: [
                  {
                    path: "",
                    name: i18n.t("SETTING.CHAT.COPYRIGHT.TITLE_BEFORECHAT"),
                    component: () =>
                      import("../views/main/setting/chat/sys/beforeChat.vue"),
                  },
                  {
                    path: "/setting/chat/sys/:countryId/onChat",
                    name: i18n.t("SETTING.CHAT.COPYRIGHT.TITLE_ONCHAT"),
                    component: () =>
                      import("../views/main/setting/chat/sys/onChat.vue"),
                  },
                  {
                    path: "/setting/chat/sys/:countryId/serviceType",
                    name: i18n.t("SETTING.CHAT.COPYRIGHT.SERVICE_TYPE.TITLE"),
                    component: () =>
                      import("../views/main/setting/chat/sys/serviceType.vue"),
                  },
                  {
                    path: "/setting/chat/sys/:countryId/satisfaction",
                    name: i18n.t("SETTING.CHAT.COPYRIGHT.TITLE_SAT"),
                    component: () =>
                      import("../views/main/setting/chat/sys/satisfaction.vue"),
                  },
                  {
                    path: "/setting/chat/sys/:countryId/ECSatisfaction",
                    name: i18n.t("SETTING.CHAT.COPYRIGHT.TITLE_EC_SAT"),
                    component: () =>
                      import(
                        "../views/main/setting/chat/sys/ECSatisfaction.vue"
                      ),
                  },
                  {
                    path: "/setting/chat/sys/:countryId/videoCall",
                    name: i18n.t("SETTING.CHAT.COPYRIGHT.TITLE_VIDEOCALL"),
                    component: () =>
                      import("../views/main/setting/chat/sys/videoCall.vue"),
                  },
                ],
              },
              {
                path: "/setting/chat/video",
                name: "視訊設定 - 選擇國家",
                component: () =>
                  import("../views/main/setting/_SelectLoginUserCountry.vue"),
              },
              {
                path: "/setting/chat/video/:countryId",
                name: "視訊設定",
                component: () => import("../views/main/setting/chat/video.vue"),
              },
              // canned
              {
                path: "/setting/chat/canned",
                name: i18n.t("SETTING.CANNED.PUBLIC_CANNED_SELECT_COUNTRY"),
                component: () =>
                  import("../views/main/setting/_SelectLoginUserCountry.vue"),
                meta: {
                  childPath: "public",
                },
              },
              {
                path: "/setting/chat/canned/:countryId/public",
                name: "",
                component: () =>
                  import("../views/main/setting/chat/canned/index.vue"),
                children: [
                  {
                    path: "",
                    name: i18n.t("SETTING.CANNED.PUBLIC_CANNED"),
                    component: () =>
                      import("../views/main/setting/chat/canned/public.vue"),
                  },
                  {
                    path: "/setting/chat/canned/:countryId/agent",
                    name: i18n.t("SETTING.CANNED.AGENT_CANNED"),
                    component: () =>
                      import("../views/main/setting/chat/canned/agent.vue"),
                  },
                  {
                    path: "/setting/chat/canned/:countryId/group",
                    name: i18n.t("SETTING.CANNED.MANAGE_GROUP"),
                    component: () =>
                      import("../views/main/setting/chat/canned/group.vue"),
                  },
                  {
                    path: "/setting/chat/canned/:countryId/quick",
                    name: i18n.t("SETTING.CANNED.IDLE_QUICK"),
                    component: () =>
                      import("../views/main/setting/chat/canned/quick.vue"),
                  },
                ],
              },
              {
                path: "/setting/chat/canned/:countryId/create",
                name: i18n.t("SETTING.CANNED.CREATE_PUBLIC_CANNED"),
                component: () =>
                  import("../views/main/setting/chat/canned/create.vue"),
              },
              {
                path: "/setting/chat/canned/:countryId/:cannedId",
                name: i18n.t("SETTING.CANNED.EDIT_PUBLIC_CANNED"),
                component: () =>
                  import("../views/main/setting/chat/canned/edit.vue"),
              },
              // customer bulletin
              {
                path: "/setting/chat/customerBulletin",
                name: i18n.t("SETTING.CHAT.BULLETIN.SELECT_COUNTRY"),
                component: () =>
                  import("../views/main/setting/_SelectLoginUserCountry.vue"),
              },
              {
                path: "/setting/chat/customerBulletin/:countryId/create",
                name: i18n.t("SETTING.CHAT.BULLETIN.TITLE_CREATE"),
                component: () =>
                  import(
                    "../views/main/setting/chat/customerBulletin/create.vue"
                  ),
              },
              {
                path: "/setting/chat/customerBulletin/:countryId",
                name: i18n.t("SETTING.CHAT.BULLETIN.TITLE_LIST"),
                component: () =>
                  import(
                    "../views/main/setting/chat/customerBulletin/list.vue"
                  ),
              },
              {
                path: "/setting/chat/customerBulletin/:countryId/:id",
                name: i18n.t("SETTING.CHAT.BULLETIN.TITLE_EDIT"),
                component: () =>
                  import("../views/main/setting/chat/customerBulletin/_id.vue"),
              },
            ],
          },
          // Bulletin
          {
            path: "/setting/bulletin",
            component: () => import("../views/main/setting/bulletin/index.vue"),
            meta: { name: "Bulletin" },
            children: [
              {
                path: "",
                name: i18n.t("SETTING.BULLETIN.SELECT_COUNTRY"),
                component: () =>
                  import("../views/main/setting/_SelectLoginUserCountry.vue"),
              },
              {
                path: "/setting/bulletin/:countryId",
                name: i18n.t("SETTING.BULLETIN.TITLE_LIST"),
                component: () =>
                  import("../views/main/setting/bulletin/list.vue"),
              },
              {
                path: "/setting/bulletin/:countryId/create",
                name: i18n.t("SETTING.BULLETIN.TITLE_CREATE"),
                component: () =>
                  import("../views/main/setting/bulletin/create.vue"),
              },
              {
                path: "/setting/bulletin/:countryId/:id",
                name: i18n.t("SETTING.BULLETIN.TITLE_EDIT"),
                component: () =>
                  import("../views/main/setting/bulletin/_id.vue"),
              },
            ],
          },
          // Notice
          {
            path: "/setting/notice",
            component: () => import("../views/main/setting/notice/index.vue"),
            meta: { name: "Notice" },
            children: [
              {
                path: "",
                name: i18n.t("SETTING.NOTICE.SELECT_COUNTRY"),
                component: () =>
                  import("../views/main/setting/_SelectLoginUserCountry.vue"),
              },
              {
                path: "/setting/notice/:countryId",
                name: i18n.t("SETTING.NOTICE.SELECT_ASP"),
                component: () => import("../views/main/setting/_SelectASP.vue"),
              },
              {
                path: "/setting/notice/:countryId/:aspId",
                name: i18n.t("SETTING.NOTICE.TITLE"),
                component: () =>
                  import("../views/main/setting/notice/notice.vue"),
              },
            ],
          },
          // Country
          {
            path: "/setting/country",
            name: "Country Setting",
            component: () => import("../views/main/setting/country.vue"),
            meta: { name: "Country" },
          },
          // ASP
          {
            path: "/setting/asp",
            component: () => import("../views/main/setting/ASP/index.vue"),
            meta: { name: "ASP" },
            children: [
              {
                path: "",
                name: i18n.t("SETTING.ASP.SELECT_COUNTRY"),
                component: () => import("../views/main/setting/ASP/list.vue"),
              },
              {
                path: "/setting/asp/:countryId",
                name: i18n.t("SETTING.ASP.TITLE"),
                component: () =>
                  import("../views/main/setting/ASP/_countryId.vue"),
              },
            ],
          },
          // Skill
          {
            path: "/setting/skill",
            component: () => import("../views/main/setting/skill/index.vue"),
            meta: { name: "Skill" },
            children: [
              {
                path: "/setting/skill/country",
                name: i18n.t("SETTING.SKILL.COUNTRY.SELECT_COUNTRY"),
                component: () =>
                  import("../views/main/setting/_SelectLoginUserCountry.vue"),
              },

              {
                path: "/setting/skill/region",
                name: i18n.t("SETTING.SKILL.REGION.TITLE"),
                component: () =>
                  import("../views/main/setting/skill/regionSkillList.vue"),
              },

              {
                path: "/setting/skill/schedule",
                name: i18n.t("SETTING.SKILL.SCHE.SELECT_COUNTRY"),
                component: () =>
                  import("../views/main/setting/_SelectLoginUserCountry.vue"),
                meta: {
                  childPath: "",
                },
              },
              {
                path: "/setting/skill/schedule/:countryId",
                name: i18n.t("SETTING.SKILL.SCHE.TITLE"),
                component: () =>
                  import("../views/main/setting/skill/editCountrySchedule.vue"),
              },
              {
                path: "/setting/skill/country/:countryId/create",
                name: i18n.t("SETTING.SKILL.COUNTRY.FORM_TITLE_CREATE"),
                component: () =>
                  import("../views/main/setting/skill/createCountrySkill.vue"),
              },
              {
                path: "/setting/skill/country/:countryId",
                name: i18n.t("SETTING.SKILL.COUNTRY.TITLE"),
                component: () =>
                  import("../views/main/setting/skill/_countryId.vue"),
              },
              {
                path: "/setting/skill/country/:countryId/:skillId",
                name: i18n.t("SETTING.SKILL.COUNTRY.FORM_TITLE_EDIT"),
                component: () =>
                  import("../views/main/setting/skill/_countryId_skillId.vue"),
              },
            ],
          },
          // User
          {
            path: "/setting/user",
            component: () => import("../views/main/setting/user/index.vue"),
            meta: { name: "User" },
            children: [
              {
                path: "",
                component: () => import("../views/main/setting/user/list.vue"),
                name: i18n.t("SETTING.ACC.TITLE"),
                meta: { keepAlive: true },
              },
              {
                path: "/setting/user/create",
                component: () =>
                  import("../views/main/setting/user/create.vue"),
                name: i18n.t("SETTING.ACC.TITLE_CREATE"),
              },
              {
                path: "/setting/user/:id",
                component: () => import("../views/main/setting/user/_id.vue"),
                name: i18n.t("SETTING.ACC.TITLE_EDIT"),
              },
            ],
          },
          // EC LoginSwitch
          {
            path: "/setting/ECLoginSwitch",
            meta: { name: "ECLoginSwitch" },
            component: () => import("../views/main/setting/ECLoginSwitch.vue"),
          },
          // ChatGPT
          {
            path: "/setting/chatgpt",
            component: () => import("../views/main/setting/ChatGPT/index.vue"),

            children: [
              {
                path: "",
                component: () =>
                  import("../views/main/setting/_SelectLoginUserCountry.vue"),
                name: i18n.t("SETTING.GPT.SELECT_COUNTRY"),
                meta: {
                  parent: "Setting",
                  child: "ChatGPT",
                },
              },
              {
                path: "/setting/chatgpt/:countryId",
                component: () =>
                  import("../views/main/setting/ChatGPT/_country.vue"),
                children: [
                  {
                    path: "",
                    name: i18n.t("SETTING.GPT.TITLE"),
                    component: () =>
                      import("../views/main/setting/ChatGPT/basic.vue"),
                  },
                  {
                    path: "/setting/chatgpt/:countryId/decisionTree",
                    name: i18n.t("SETTING.GPT.DECISION_TREE"),
                    component: () =>
                      import("../views/main/setting/ChatGPT/decisionTree.vue"),
                  },
                  {
                    path: "/setting/chatgpt/:countryId/satisfaction",
                    name: i18n.t("SETTING.GPT.SAT.TITLE"),
                    component: () =>
                      import("../views/main/setting/ChatGPT/satisfaction.vue"),
                  },
                  {
                    path: "/setting/chatgpt/:countryId/SNBlock",
                    name: i18n.t("SETTING.GPT.SN_BLOCK.TITLE"),
                    component: () =>
                      import("../views/main/setting/ChatGPT/SN_block.vue"),
                  },
                ],
              },
            ],
          },
          {
            path: "/setting/funnelChart",
            name: "Setting Funnel Chart (Beta)",
            component: () => import("../views/main/setting/funnelChart.vue"),
          },
          // SNBlock
          {
            path: "/setting/SNBlock",
            component: () => import("../views/main/setting/SNBlock/index.vue"),

            children: [
              {
                path: "",
                component: () =>
                  import("../views/main/setting/_SelectLoginUserCountry.vue"),
                name: "SN Block Setting",
                meta: {
                  parent: "Setting",
                  child: "SNBlock",
                },
              },
              {
                path: "/setting/SNBlock/:countryId",
                name: "SN Block Setting Country",
                component: () =>
                  import("../views/main/setting/SNBlock/_country.vue"),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/cms_login",
    component: () => import("../views/auth/cms_login.vue"),
    name: "cms_login",
  },
  {
    path: "/login",
    component: () => import("../views/auth/index.vue"),
    children: [
      {
        path: "",
        component: () => import("../views/auth/login.vue"),
        name: "login",
      },
    ],
  },
  {
    path: "/verifyLoginMail",
    name: "verify-login-mail",
    component: () => import("../views/auth/verifyLoginMail.vue"),
  },
  {
    path: "/forgetpkey",
    name: "forget-pkey",
    component: () => import("../views/auth/forgetpkey.vue"),
  },
  {
    path: "/resetPkeySuccess",
    name: "resetPkey-Success",
    component: () => import("../views/auth/resetPkeySuccess.vue"),
  },
  {
    path: "/resetpkey/:token",
    name: "reset-pkey",
    component: () => import("../views/auth/resetpkey.vue"),
  },
  {
    path: "/DownloadFile",
    name: "download-file",
    component: () => import("../views/DownloadFile.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "hash",
  linkActiveClass: "active",
});

// 路由守衛
router.beforeEach((to, from, next) => {
  let token = store.getters["account/isAuthenticated"];
  let isVideoReady = store.getters["videoCallRTC/ready"];

  if (isVideoReady) {
    // 視訊正在進行中，禁止跳轉。
    Vue.prototype.$alert("Please end the current video chat first", "Message", {
      type: "error",
      iconClass: "el-icon-info",
      confirmButtonText: "OK",
      center: true,
    });
    return;
  }
  if (to.matched.some((m) => m.meta.check)) {
    Vue.prototype.$bus.$emit("checkPreventLeave");
    let preventLeave = store.state.global.preventLeaveRoom;
    if (preventLeave) {
      Vue.prototype
        .$confirm(
          i18n.t("LAYOUT.BEFORE_CHANGE_ROOM"),
          i18n.t("NOTIFICATION.SYS"),
          {
            confirmButtonText: i18n.t("NOTIFICATION.CONFIRM"),
            cancelButtonText: i18n.t("NOTIFICATION.CANCEL"),
            type: "warning",
          },
        )
        .then(() => {
          // AP-12932 換房間不再清空失敗訊息佇列，保留給自動補送
          next();
        })
        .catch(() => {});
    } else {
      next();
    }
  } else if (to.matched.some((m) => m.meta.requireAuth)) {
    if (!token) {
      Vue.prototype.$message({
        message: i18n.t("LAYOUT.MSG_LOGIN_AGAIN"),
        center: true,
        iconClass: "el-icon-circle-check",
        customClass: "msg msg-error",
      });

      next("/login");
    } else {
      if (to.meta.parent && to.meta.child) {
        // chatgpt路由權限測試(其他路由未實現)
        let role = JSON.parse(localStorage.getItem("AC_userdata")).roles[0];
        const pass = auth(to.meta.parent, to.meta.child, role);
        // console.log("pass", pass);
        if (pass) {
          next();
        } else {
          console.log("Permission not allowed.");
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
